import { useEffect, useRef, useState } from "react";
import { useAuth } from "react-oidc-context";
import TameeniLoaderOverlay from "@/ui/loader/tameeni-loader-overlay";
import { usePostLogin } from "@/features/authentication";

type AuthPreloadRoutesProps = {
  children: React.ReactNode;
};

const AuthPreloadRoutes = ({ children }: AuthPreloadRoutesProps) => {
  const { isLoading, signinSilent } = useAuth();
  const [hasCompletedInitialLoad, setHasCompletedInitialLoad] = useState(false);
  const silentSigninTriggeredRef = useRef(false);

  useEffect(() => {
    if (!isLoading && !hasCompletedInitialLoad) {
      setHasCompletedInitialLoad(true);
    }
  }, [isLoading, hasCompletedInitialLoad]);

  useEffect(() => {
    if (silentSigninTriggeredRef.current) return;
    silentSigninTriggeredRef.current = true;
    signinSilent();
  }, [signinSilent]);

  usePostLogin();

  if (isLoading && !hasCompletedInitialLoad) {
    return <TameeniLoaderOverlay transparent={false} />;
  }

  return <>{children}</>;
};

export default AuthPreloadRoutes;
